import { ChannelkartNetworkGet, ChannelkartNetworkPost } from "../../services/networkService";
import { getMetaData } from "../../services/uiConfigService";
import { validateWithOtp } from "../../stateManagement/actions/validateOtpPopupActions";
import { manageUpdateAccessObj } from "../manageUpdateAccess/manageUpdateAccessTypes";
import {
  dbAndOutletLevel,
  DropDownItem,
  DropDownStateData,
  geoFencingOption,
  regionSpecificGioDistanceInputField,
} from "./updateGeofenceTypes";
import {
  ATTENDANCE_DATA_CONFIG_DOMAIN_NAME,
  ATTENDANCE_DATA_DOMAIN_TYPE,
  DB_AND_OUTLET_LEVELS,
  DB_AND_OUTLET_POST_REQUEST_KEY_VALUE_MAPPING,
  DB_AND_OUTLET_REGIONS_LIST,
  GEO_FENCING_OPTIONS,
} from "./updateGeofenceUtils";

//getting data from utils
export const getGeoFencingOptions = (): geoFencingOption[] => {
  return GEO_FENCING_OPTIONS;
};
export const getDbAndOutletLevels = (): dbAndOutletLevel[] => {
  return DB_AND_OUTLET_LEVELS;
};
//getting data from config
export const getAttendanceDataFromConfig = async (): Promise<
  regionSpecificGioDistanceInputField[]
> => {
  const metaData = await getMetaData(ATTENDANCE_DATA_CONFIG_DOMAIN_NAME,ATTENDANCE_DATA_DOMAIN_TYPE);
  return metaData || [];
};
//getting data from api calls
/*
d util list , so just return that 
   2. if level is > 0 , then we make an api call to get the data based on the just previous level 
    2.1 first check in the allInputsData if the key with value levelInfo.level - 1 is present or not
    2.2 if it is not present then return empty array
    2.3 if it is presemt then 
      2.3.1 filter paramerter is the id of the levelInfo.level - 1 ( from getLevelInfoFromLevelNumber(levelInfo.level - 1).id)
      2.3.2 filter value is the value of the levelInfo.level - 1 ( obtained from allInputsData)
      2.3.3 make the api call in the format 
    2.4 conver the data in the DropDownItem[] format { code , value} the value of code and value will depend on the levelInfo.id 
*/
export const getDataForTheDropDown = async (
  levelInfo: dbAndOutletLevel,
  allInputsData: Record<number, DropDownStateData>
): Promise<DropDownItem[]> => {
  // Step 1: Check if level is 0 (region level)
  if (levelInfo.level === 0) {
    return getHardcodedRegionList();
  }

  // Step 2: Check if the previous level's data is available in `allInputsData`
  const previousLevelInfo = getPreviousLevelInfo(levelInfo.level,allInputsData);
  if (previousLevelInfo.level===-1 || !previousLevelInfo?.data?.value) {
    console.warn(`No selected value found for level ${levelInfo.level - 1}`);
    return [];
  }
  
  // Step 3: Prepare the API request parameters
  // const prevoisLevelData = getLevelInfoFromLevelNumber(levelInfo.level - 1);
  const filterParameter = levelInfo.searchParameter || ""; // ID of the previous level
  const filterValue = previousLevelInfo.data.value || ""; // Value of the previous level

  try {
    // Step 4: Make the API call
    let apiResponse = [];
    if(levelInfo.id !== "userName" && levelInfo.id !== "outletCode"){
     apiResponse = await fetchDropDownDataBasedOnFilterParameterAndValue(filterParameter, filterValue);
    }
    else{
      apiResponse = await fetchDropDownDataBasedOnSearchParameter(filterParameter);
    }
    // Step 5: Transform the response into `DropDownItem[]` format
    const dropdownItems = getDropDownDataInCorrectFormat(apiResponse, levelInfo);
    

    return dropdownItems;
  } catch (error) {
    console.error("Error fetching data for the dropdown:", error);
    throw new Error("Error fetching data for the dropdown");
  }
};
export const getHardcodedRegionList = (): DropDownItem[] => {
  return DB_AND_OUTLET_REGIONS_LIST.map((region)=>{
    return {
      code : region.id,
      value : region.label,
      label: region.label
    }
  });
}
// export const getLevelInfoFromLevelNumber = (level:number) : dbAndOutletLevel => {
//   return getDbAndOutletLevels().find((levelInfo)=>levelInfo.level === level) || {id : "", label : "", level : -1 , searchParameter:""};
// }
export const getPreviousLevelInfo = (level:number,allInputsData: Record<number, DropDownStateData>) : DropDownStateData  => {
  const previousLevel = level - 1;
  // Check if key with value = previousLevel exists in the allInputsData and store in previousLevelInfo
  const previousLevelInfo = Object.keys(allInputsData).find((acc, key) => {
    const numericKey = Number(key);
    if (numericKey === previousLevel) {
      return  allInputsData[numericKey];
    }
  });
  if (!previousLevelInfo) {
    console.warn(`No information found for previous level: ${previousLevel}`);
    return {level : -1, data : {code : "", value : "", label : ""}};
  }
  else{
    return allInputsData[previousLevel]
  }

}
export const fetchDropDownDataBasedOnSearchParameter = async (searchParameter: string) => {
  try {
    const response = await ChannelkartNetworkGet(`/${searchParameter}`);
    if(response.status===200){
      return response?.data?.features
    }
    else{
      throw new Error("Error fetching data from the API");
    }
  } catch (error) {
    throw new Error("Error fetching data from the API");

  }
}
export const fetchDropDownDataBasedOnFilterParameterAndValue = async (filterParameter: string, filterValue: string) => {
  try {
    const response = await ChannelkartNetworkGet(`/locations?filter=${filterParameter}:${encodeURIComponent(filterValue)}`);
    if(response.status===200){
      return response?.data?.features
    }
    else{
      throw new Error("Error fetching data from the API");
    }
  } catch (error) {
    throw new Error("Error fetching data from the API");
  }

}
export const getDropDownDataInCorrectFormat = (
  data: Record<string, any>, 
  levelInfo: dbAndOutletLevel
): DropDownItem[] => {
  const levelId = levelInfo.id;

  // Map data to DropDownItem and filter out invalid items
  const dropdownItems: DropDownItem[] = data
    .map((item: any) => getDropDownItemFromDataItem(item, levelId))
    .filter((item: DropDownItem | {}): item is DropDownItem => Object.keys(item).length > 0);

  // Filter to remove duplicate labels
  const uniqueDropdownItems: DropDownItem[] = [];
  const seenLabels = new Set<string>();

  dropdownItems.forEach(item => {
    if (item.label && !seenLabels.has(item.label)) {
      uniqueDropdownItems.push(item);
      seenLabels.add(item.label);
    }
  });

  return uniqueDropdownItems;
};
export const getDropDownItemFromDataItem = (item: any, levelId: string): DropDownItem | {} => {
  let code : string;
  let value : string;
  let label : string;
  switch(levelId){
   case "state":{
    code = item.stateCode?.trim();
    value = item.state?.trim();
    label = (value + '-' + code).trim();
    break;
   }
   case "area":{
    code = item.areacode?.trim();
    value = item.area?.trim();
    label = (value + '-' + code).trim();
    break;
   }
   case "territory":{
    code = item.territoryCode?.trim();
    value = item.territory?.trim();
    label = (value + '-' + code).trim();
    break;
   }
   case "district":{
    code = item.districtCode?.trim();
    value = item.district?.trim();
    label = (value + '-' + code).trim();
    break;
   }
   case "town":{
    code = item.townCode?.trim();
    value = item.town?.trim();
    label = (value + '-' + code).trim();
    break;
   }
   case "userName":{
    code = item.loginId?.trim();
    value = item.loginId?.trim();
    label = value;
    break;
   }
   case "outletCode":{
    code = item.outletCode?.trim();
    value = item.outletName?.trim();
    label = (value + '-' + code).trim();
    break;
   }
   default:{
    code = "";
    value = "";
    label = "";
    break;
   }

  }
  if(!code || !value || !label){
   return {}
  }
  return {
   code : code,
   value : value,
   label : label,
  }
}
export const saveAttendanceData = async (formValues: regionSpecificGioDistanceInputField[], openPopUp ?: any) => {
  try{
    const updateRequestBody = {
      lob: JSON.parse(localStorage.authContext).user.lob,
      domainName: ATTENDANCE_DATA_CONFIG_DOMAIN_NAME,
      domainType: ATTENDANCE_DATA_DOMAIN_TYPE,
      domainValues : formValues
    }
    const api =  `/metadata/${updateRequestBody.domainName}?name=${updateRequestBody.domainType}`;
    const apiType = "PUT";
    validateWithOtp(
      (verifiedUser, verifyResponse) => {
        if (verifyResponse.status === 200 || verifyResponse.status === 201) {
          openPopUp("Data saved successfully", "Success");
        } else {
          throw new Error("Some error occured while saving data");
        }
      },
      undefined,
      "all",
      api,
      updateRequestBody,
      apiType
);
  } catch (error) {
    throw new Error("Error saving attendance data");
  }
}
export const getConvertedDbAndOutletValue = (value : DropDownStateData) : [string, any] => {
  const keyValues = DB_AND_OUTLET_POST_REQUEST_KEY_VALUE_MAPPING;
  const  keyValue : string = keyValues.find((keyValue)=>keyValue.level === value.level)?.value || "";
  return [keyValue,value.data?.code];
}
export const convertDbAndOutletData = (inputValues: Record<number, DropDownStateData>, distance: string): any => {
  const data = Object.keys(inputValues).reduce((acc, level) => {
    const [key, value] = getConvertedDbAndOutletValue(inputValues[Number(level)]);
    acc[key] = value;
    return acc;
  }, {} as Record<string, any>);
  const country = JSON.parse(localStorage.authContext)?.user?.countryCode;
  return {
    ...data,
    "geoDist" : distance,
    "country" : country
  }
}

export const saveDbAndOutletData = async (data : any) => {
  try {
    const api = "/tasks/types/outletupdate/execute";
    const response = await ChannelkartNetworkPost(api,{
      "attributes" : data
    });
    if(response.status===200){
      return response;
    }
    else{
      throw new Error("Error saving data");
    }
  } catch (error) {
    throw new Error("Error saving data");
  }
}